<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;" class="jcsb">
            <div>{{title}}</div>
        </div>
        <div style="margin-top: 20px; ">
            <Table :columns="columns" :data="items"></Table>
            <div style="margin-top: 20px;padding:0 20px;display: flex;align-items: center;">
                <Input search style="width: 200px;margin-right: 20px;" size="small" placeholder="搜索" v-model="query.keywords" @on-enter="keywordsChanged"></Input>
                <Page placement="top" :page-size-opts="[10,20,50,100,200]" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" @on-page-size-change="pageSizeChanged" show-sizer show-total size="small"></Page>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            dataurl: String,
            dataquery: Object,
            // 下发门店列表
            // items: {
            //     type: Array,
            //     default: () => []
            // },
            title: {
                type: String,
                default: '适用机构'
            }
        },
        data() {
            return {
                loading: false,
                total: 0,
                page: {
                    size: 10,
                    current: 1
                },
                query: {
                    keywords: "",
                },
                usedKeywords: '',
                items: [],
                selections: [],
                columns: [
                    { title: '编号', key: 'code' },
                    { title: '机构名称', key: 'name' },
                    { title: '经营方式', key: 'jingyingfangshi' },
                    { title: '上级机构', key: 'parentStr' },
                    { title: '品牌', key: 'pinpaiStr' },
                ]
            }
        },
        mounted() {},
        methods: {
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            sortChanged() {
                this.page.current = 1
                this.loadData()
            },
            loadData() {
                this.loading = true
                this.$api.post(this.dataurl, {
                    query: this.query,
                    // fields: this.option.fields,
                    page: this.page
                }).then(res => {
                    this.loading = false
                    this.items = res.data.items
                    this.total = res.data.total
                    this.getparentStr()
                }, () => {
                    this.loading = false
                })
            },
            getparentStr() {
                for (const i of this.items) {
                    i.parentStr = i.parent ? i.parent.name : ''
                }
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
        },
        created() {
            // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
            if (this.dataquery) {
                for (let key of Object.keys(this.dataquery)) {
                    this.query[key] = this.dataquery[key]
                }
            }
            this.loadData()
        },
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/ShiyongjigouTable.vue?4dec6718